import { UPDATE_TENANT_INFO } from '../types'

const state = {
  tenantInfo: null,
}

const getters = {
  buses: (state) => {
    return state.tenantInfo ? state.tenantInfo.buses : []
  },
}

const mutations = {
  [UPDATE_TENANT_INFO](state, tenantInfo) {
    state.tenantInfo = tenantInfo
  },
}

export default {
  state,
  getters,
  mutations,
}
